import {
  AuthActionTypes,
  AccountType,
  CreateUserObject,
  EmailLoginCredentials,
  EMAIL_LOGIN,
  FACEBOOK_LOGIN,
  GOOGLE_LOGIN,
  SIGN_UP,
  PASSWORD_RESET_EMAIL,
  PASSWORD_RESET,
  CHANGE_PASSWORD,
} from './types';

export const emailLogin = (
  credentials: EmailLoginCredentials,
  accountType: AccountType
): AuthActionTypes => ({
  type: EMAIL_LOGIN,
  credentials,
  accountType,
});

export const googleLogin = (accountType: AccountType): AuthActionTypes => ({
  type: GOOGLE_LOGIN,
  accountType,
});

export const facebookLogin = (accountType: AccountType): AuthActionTypes => ({
  type: FACEBOOK_LOGIN,
  accountType,
});

export const signUp = (
  accountType: AccountType,
  user: CreateUserObject
): AuthActionTypes => ({
  type: SIGN_UP,
  accountType,
  user,
});

export const passwordResetEmail = (email: string) => ({
  type: PASSWORD_RESET_EMAIL,
  email,
});

export const resetPassword = (code: string, password: string) => ({
  type: PASSWORD_RESET,
  code,
  password,
});

export const changePassword = (
  email: string,
  currentpassword: string,
  newpassword: string
) => ({
  type: CHANGE_PASSWORD,
  email,
  currentpassword,
  newpassword,
});
